import React from "react";
import '../HomePage/HomeInsurance.css';
import editingDetail from '../Images/Editing-icon.png';
import ProposalFormDetail from "./ProposalFormDetail.jsx";
import ProposalForm from "./ProposalForm.jsx";
import HomePlan from "./HomePlan.jsx";



const Summary = (props) => {
    return (
        <>
            <div className="homeOwner_Detail">
                <div className="home_detail2">
                    <h4>Home Owner Details</h4>
                   {/* <div className="text-end OwnerEditbtn">
                        <button onClick=''>
                            <img className="" src={editingDetail} alt="Home Insurance at Lowest Rates" />
                            Edit
                        </button>
                    </div>*/}
                </div>
                <div className="mt-3">
                    <div className="summaryPage">
                        <div className="owner_detail owner_detail1">
                            <small>Full Name</small>
                            <p>{props.data?.FullName}</p>
                        </div>
                        <div className="owner_detail owner_detail1">
                            <small>Mobile Number</small>
                            <p>{props.data?.mobileno}</p>
                        </div>
                        <div className="owner_detail">
                            <small>Email Address</small>
                            <p>{props.data?.EmailID}</p>
                        </div>
                        <div className="owner_detail owner_detail1">
                            <small>Gender</small>
                            <p>{props.data?.gender}</p>
                        </div>
                        <div className="owner_detail owner_detail1">
                            <small>Date of Birth</small>
                            <p>{props.data?.dateOfBirth}</p>
                        </div>
                        <div className="owner_detail owner_detail1">
                            <small>Address</small>
                            <p className="summary_address">{props.data?.addressType}</p>
                        </div>
                        <div className="owner_detail owner_detail1">
                            <small>PIN Code</small>
                            <p>{props.data?.pinCode}</p>
                        </div>

                    {/*<div className="summaryPage2">
                        <div className="owner_detail2">
                            <small>Address</small>
                            <p>{props.data?.addressType}</p>
                        </div>
                        <div className="owner_detail3">
                            <small>PIN Code</small>
                            <p>{props.data?.pinCode}</p>
                        </div>
                    </div>*/}
                    </div>
                </div>
            </div>

        </>
    );
}

export default Summary;